export default __webpack_public_path__ + "static/media/3d-vizualizacija.fd2769c7.gif";